import { IImage } from '@gn-audio/core/api/product-catalogue/models/image';

export const customPaging = (images: IImage[], index: number, productName: string): string => {
  return `
    <button type="button" role="button" data-role="none">
      <img src="${images[index].url}?w=50&h=50&auto=format" alt="${productName}" />
    </button>
  `;
};
